export default __webpack_public_path__ + "static/media/locations.c145a51a.svg";